import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const LiabilityLossComponent = (props) => (
    <div>
        <ReportSectionHeader>
        {
        "Potential Embedded SCA Loss (Present Day)"
    	}
        </ReportSectionHeader>
        <ReportTable
            settings={[
                {
                    header: '', 
                    accessor: 'name',
                },
                {
                    header: '',
                    accessor: 'loss',
 					dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                },
            ]}
            data={props.liabilityLoss}
            name={"liabilityLoss"}
           
        />
    </div>
);


export default LiabilityLossComponent;


// WEBPACK FOOTER //
// ./src/common/components/LiabilityLoss/LiabilityLoss.js